<template>
  <div>
	<loading :active.sync="isLoading" color="#64B9B0"></loading>
	<div class="content-wrapper">
	  <div class="container-fluid">
		<!-- Breadcrumbs-->
			<ol class="breadcrumb">
				<li class="breadcrumb-item">
				<router-link to="/adm/titulares">Titulares</router-link>
				</li>
				<li class="breadcrumb-item active">Detalhes Titular</li>
			</ol>

			<div class="box_general padding_bottom">
				<div class="header_box version_2">
				<h2>
					<i class="fa fa-info-circle"></i>Informações do Titular
				</h2>
			</div>
					
				<div class="row">
					<div class="col-md-4">
						<div class="form-group">
							<label>Nome do Dependente</label>
							<input
								type="text"
								class="form-control"
								v-model="dependente.name"
							/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
						<label>CPF do Dependente</label>
						<input
							type="text"
							class="form-control"
							v-mask="['###.###.###-##']"
							v-model="dependente.cpf"
						/>
						</div>
					</div>
						
					<div class="col-md-4">
						<div class="form-group">
						<label>RG do Dependente</label>
						<input
							type="text"
							class="form-control"
							v-model="dependente.rg"
						/>
						</div>
					</div>
				</div>

				<div class="row">

          <div class="col-md-4">
						<div class="form-group">
						<label>E-mail do Dependente</label>
						<input
							type="text"
							class="form-control"
							v-model="dependente.email"
						/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>Nome da Mae</label>
							<input
							type="text"
							class="form-control"
							v-model="dependente.nome_mae"
							/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>Nome do Pai</label>
							<input
							type="text"
							class="form-control"
							v-model="dependente.nome_pai"
							/>
						</div>
					</div>
				</div>

        <div class="row">

          <div class="col-md-4">
						<div class="form-group">
						<label>Carteirinha</label>
						<input
							type="text"
							class="form-control"
							v-model="dependente.carteirinha"
						/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>Naturalidade</label>
							<input
							type="text"
							class="form-control"
							v-model="dependente.naturalidade"
							/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>Plano</label>
							<v-select 
								:options="planos" 
								:reduce="plano => plano.id"
								v-model="dependente.plan_id" 
								label="valor" />
						</div>
					</div>
				</div>

				<div class="row">

          <div class="col-md-4">
						<div class="form-group">
							<label>Assinante</label>
							<v-select 
								:options="subscribers" 
								:reduce="subscriber => subscriber.id"
								v-model="subscriber_id" 
								label="valor" />
							<!-- <select
							v-model="dependente.subscribers_id"
							class="form-control"
							>
								<option
									v-for="(subscriber,index) in subscribers"
									:key="index"
									:value="subscriber.id"
								>{{subscriber.id}}</option>
			  			</select> -->
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>Data de Nascimento</label>
							<date-picker
								v-model="dependente.birth_date"
								:lang="lang"
								format="DD/MM/YYYY"
								value-type="format"
								></date-picker>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>CNS</label>
							<input
							type="text"
							class="form-control"
							v-model="dependente.cns"
							/>
						</div>
					</div>

					
				</div>

        <div class="row">
			<div class="col-md-4">
				<div class="form-group">
					<label>Parentesco</label>
					<input
					type="text"
					class="form-control"
					v-model="dependente.parentesco"
					/>
				</div>
			</div>

			<div class="col-md-4">
				<div class="form-group">
					<label>Estado Civil</label>
					<input
						type="text"
						class="form-control"
						v-model="dependente.estado_civil"
					/>
				</div>
			</div>

			<div class="col-md-4">
				<div class="form-group">
					<label>Gênero</label>
					<input
						type="text"
						class="form-control"
						v-model="dependente.genero"
					/>
				</div>
			</div>
			
        </div>
				<div class="row">
					<div class="col-md-12 mt-5">
						<p class="pull-right">
							<button class="btn_1 medium" @click="cria_dependente()">Criar Dependente</button>
						</p>
					</div>
				</div>

			</div>
		</div>
	</div>
</div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from 'axios'

export default {
  mixins: [funcoesGerais],
  data() {
		return {
			lang: {
			days: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
			months: [
			"Jan",
			"Fev",
			"Mar",
			"Abr",
			"Mai",
			"Jun",
			"Jul",
			"Ago",
			"Set",
			"Out",
			"Nov",
			"Dec"
			],
			pickers: [
			"prox 7 dias",
			"prox 30 dias",
			"7 dias anteriores",
			"30 dias anteriores"
			],
			placeholder: {
				date: "Selecione a data",
				dateRange: "Selecione o intervalo"
			}
			},
      subscriber_id: '',
			dependente: {},
			subscribers: [],
			request: {},
      planos: [],
			isLoading: false,
		};
	},

	created() {
		let self = this;
		self.isLoading = true;

		ajax("get", "usuarios").then(res => {
			self.isLoading = false;
			let subscribersRes = res.data;
			for(let sub of subscribersRes) {
				if(sub.subscriber) {
					sub.subscriber.valor = `${sub.name} - ${sub.subscriber.id}`;
					self.subscribers.push(sub.subscriber);
				}
			}

		}).catch(e => {
			self.isLoading = false;
			tratamento_requisicao(e);
		})

    ajax("get", "/planos").then(res => {
			self.isLoading = false;
			let planosRes = res;
			for(let plano of planosRes) {
				if(plano) {
					plano.valor = `${plano.id} - ${plano.name}`;
					self.planos.push(plano);
				}
			}

		}).catch(e => {
			self.isLoading = false;
			tratamento_requisicao(e);
		})
     
	},
	
  methods: {
	cria_dependente() {
		let self = this;
		self.isLoading = true;
		self.request.subscriber_id = self.subscriber_id;
		self.request.dependents = [];
		self.request.dependents[0] = self.dependente; 
      

			ajax("post", "assinantes/dependentes", self.request).then(res => {
				self.isLoading = false;
				alerta("success", "Sucesso", "Dependente criado com sucesso");
				self.$router.replace(
			self.$route.query.redirect || "/adm/dependentes"
		);6
			}).catch(err => {
				self.isLoading = false;
				tratamento_requisicao(err);
			})
		}
  }
}
</script>
